import { Reveal } from "../../lib/motion";
import { STEPS } from "../../lib/siteData";

export const Companion = () => {
  return (
    <section id="companion" data-testid="companion-section" className="relative py-28 lg:py-40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-20">
          <Reveal className="lg:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.4em] text-es-accent mb-6">
              The architecture
            </p>
            <h2 className="font-serif font-light text-es-fg tracking-tight leading-[1.02] text-[clamp(2rem,5vw,4rem)]">
              From scattered life signals to a governed legacy.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4 lg:col-start-9">
            <p className="text-es-muted-fg leading-relaxed">
              Three governed possibilities. Every asset is consented, versioned, protected,
              and provenance tagged. Each person determines how far their digital legacy may
              continue.
            </p>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-3 border-t border-l border-es-border">
          {STEPS.map((s, i) => (
            <Reveal
              key={s.title}
              delay={i * 0.1}
              className="border-r border-b border-es-border p-8 lg:p-10 group hover:bg-es-surface transition-colors duration-500"
            >
              <div className="flex items-center justify-between mb-16">
                <span className="text-[11px] uppercase tracking-[0.35em] text-es-muted-fg">
                  {`0${i + 1}`}
                </span>
                <span className="text-[11px] uppercase tracking-[0.35em] text-es-accent text-right">
                  {s.tag}
                </span>
              </div>
              <h3 className="font-serif font-light text-es-fg text-[clamp(1.6rem,2.6vw,2.4rem)] tracking-tight mb-2">
                {s.title}
              </h3>
              {s.subtitle && (
                <p className="text-es-accent text-[13px] tracking-wide mb-4">{s.subtitle}</p>
              )}
              <p className={`text-es-muted-fg leading-relaxed text-[15px] ${s.subtitle ? "" : "mt-4"}`}>
                {s.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
